<template>
<b-col>
  <h1>
    <span v-if="project">Проект {{ project.name }}</span>
    <span v-else>Новый проект</span>
  </h1>
  <b-row>
    <b-col>
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <b-form-group
          id="name-group"
          label="Название проекта:"
          label-for="name"
          description="Название проекта будет использоваться в интерфейсе."
          >
          <b-form-input
            id="name"
            v-model="form.name"
            type="text"
            required
            placeholder="Проект"
            ></b-form-input>
        </b-form-group>

        <b-form-group
          id="mango-key-group"
          label="Ключ API Mango:"
          label-for="mango-key"
          description="Ключ для интеграции Mango API."
          >
          <b-form-input
            id="name"
            v-model="form.mango_key"
            type="text"
            placeholder="vpbx_api_key"
            ></b-form-input>
        </b-form-group>

        <b-form-group
          id="mango-salt-group"
          label="Ключ для создания подписи API Mango:"
          label-for="mango-salt"
          description="Ключ, используемый для подписывания вызовов Mango API."
          >
          <b-form-input
            id="name"
            v-model="form.mango_salt"
            type="text"
            placeholder="vpbx_api_salt"
            ></b-form-input>
        </b-form-group>

        <b-card bg-variant="light" header="Домены" class="mb-3">
          <b-input-group
              class="mb-2"
              v-for="(domain, index) in form.domains"
              :id="'domain-' + index"
              :key="'domain-' + index">
            <b-form-input
              v-model="form.domains[index]"
              type="text"
              required
              placeholder="www.example.com"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="danger" @click="removeDomain(index)">
                <fa-icon icon="times-circle"/>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <template v-slot:footer>
            <b-button variant="primary" size="sm" @click="addDomain">
              <fa-icon icon="plus"/> Добавить
            </b-button>
          </template>
        </b-card>

        <b-overlay :show="keyLoading">
          <b-card bg-variant="light" header="Ключи API" class="mb-3">
            <b-input-group
              class="mb-2"
              v-for="(key, index) in form.api_keys"
              :id="'key-' + index"
              :key="'key-' + index">
              <b-form-input
                v-model="form.api_keys[index]"
                type="text"
                readonly
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="danger" @click.stop="deleteKey(index)">
                  <fa-icon icon="times-circle"/>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <template v-slot:footer>
              <b-button variant="primary" size="sm" @click.stop="generateKey">
                <fa-icon icon="plus"/> Сгенерировать
              </b-button>
            </template>
          </b-card>
        </b-overlay>

        <b-button-group>
          <b-button type="submit" variant="primary" :disabled="changed ? false : true">
            <fa-icon icon="save"/> Сохранить
          </b-button>
          <b-button type="reset" variant="danger" :disabled="changed ? false : true">
            <fa-icon icon="times-circle"/> Сбросить
          </b-button>
        </b-button-group>
      </b-form>
    </b-col>
  </b-row>
</b-col>

</template>

<script>
import { store } from "@/store";
import Utils from "@/lib/Utils";
import Api from "@/lib/Api";


export default {
    name: "ProjectEdit",
    props: [
        'projectId'
    ],
    data () {
        return {
            appState: store.state,
            keyLoading: false,
            form: {}
        };
    },
    created () {
        this.form = this.initForm();
    },
    computed: {
        project () {
            if (this.projectId === undefined) {
                return null;
            }
            const id = parseInt(this.projectId);
            const project = this.appState.projects.find(
                el => el.id === id
            );
            if (!project) {
                alert('ERRR');
            }
            return project;
        },
        changed () {
            if (this.project) {
                return (
                    this.form.name !== this.project.name ||
                    !Utils.arraysEqual(this.form.domains, this.project.domains)
                );
            }
            return true;
        }
    },
    methods: {
        initForm () {
            const form = {};
            const project = this.project;
            if (project) {
                form.name = project.name;

                form.domains = [];
                if (project.domains)
                    form.domains = project.domains.slice();
                
                form.api_keys = [];
                if (project.api_keys)
                    form.api_keys = project.api_keys.slice();

                form.mango_key = project.mango_key;
                form.mango_salt = project.mango_salt;
            }
            return form;
        },
        async onSubmit () {
            
        },
        onReset () {
            this.form = this.initForm();
        },
        async generateKey () {
            this.keyLoading = true;
            try {
                const keys = await Api.generateKey(
                    parseInt(this.projectId),
                );
                this.project.api_keys = keys.slice();
                this.form.api_keys = keys.slice();
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка генерации ключа', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.keyLoading = false;

        },
        async deleteKey (index) {
            try {
                const yes = await this.$bvModal.msgBoxConfirm(
                    'Удалить ключ?', {
                        okTitle: 'Да',
                        cancelTitle: 'Нет',
                });
                if (!yes) {
                    return;
                }
            } catch (e) {
                return;
            }
            this.keyLoading = true;
            try {
                const keys = await Api.deleteKey(
                    parseInt(this.projectId), index
                );
                this.project.api_keys = keys.slice();
                this.form.api_keys = keys.slice();
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка удаления ключа', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.keyLoading = false;

        },
        addDomain () {
            this.form.domains.push('');
        },
        removeDomain (index) {
            this.form.domains.splice(index, 1);
        }
    },
    watch: {
        projectId (oldval, newval) {
            if (oldval !== newval)
                this.form = this.initForm();
        }
    }
};
</script>
